import { StoreSchema } from '../../types/store'

export const selectUsers = (store: StoreSchema) => store.user.users
export const selectUsersIsLoading = (store: StoreSchema) => store.user.isLoading